import { useQuery } from '@tanstack/react-query';
import { addWeeks, isBefore } from 'date-fns';
import { useMemo } from 'react';

import { getChartDrawingsApi } from '@flipster/apis/v1/chart';
import { convertDate } from '@flipster/utils/datetime';

import { ResolutionString } from '../../../lib/charting_library';

export const useChartPattern = (chartPatternId: string) => {
  const { data } = useQuery({
    queryKey: ['getChartDrawingsApi', chartPatternId],
    queryFn: () => getChartDrawingsApi(chartPatternId!),
    select: (res) => {
      if (!res) return undefined;
      return {
        ...res.data,
        intervalInMins: String(res.data.intervalInMins) as ResolutionString,
      };
    },
    enabled: !!chartPatternId,
    refetchOnMount: 'always' as const,
  });

  const isExpired = useMemo(() => {
    if (!data) return false;
    const focusDate = convertDate(data.focusTime);
    if (!focusDate) return false;
    const expiredDate = addWeeks(focusDate, 1);
    return isBefore(expiredDate, new Date());
  }, [data]);

  return { data, isExpired };
};
